<template>
  <div>
    <div @click.prevent="togleBasket" class="mini-bask-mob">
      <span>
        <i>{{getBasketCount}}</i>
      </span>
    </div>
    <div class="mini-hide-bask" v-if="basket.isOpenSmallBasket">
      <div class="mini-bask-tit">
        {{basket.messages.title}} ({{getBasketCount}})
        <span class="close_basket" @click="togleBasket"></span>
      </div>

      <div class="mini-bask-list" ref="mini_bask_list">
        <div class="mini-bask-one-item" v-for="item in basket.items">
          <div class="mini-bask-one-thumb">
            <div class="one-card-check-discount-price" v-if="item.discountPercentage > 0">{{item.discountPercentageFormatted}}</div>
            <a :href="item.link">
              <img :src="item.picture" :alt="item.name" :title="item.name">
            </a>
          </div>
          <div class="mini-bask-one-descr">
            <div class="mini-bask-one-tit">
              <a :href="item.link">
                {{item.name}}
              </a>
            </div>
            <div class="mini-bask-one-info">
              <div class="mini-bask-one-info-left">
                <div class="mini-bask-one-opt" v-if="item.size">
                  {{basket.messages.sizeTitle}}: <span>{{item.size}}</span>
                </div>
                <div class="mini-bask-one-del" :data-id="item.id" @click="del(item.id)">
                  <a href="javascript:void(0);">
                  <span>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 24">
                      <title>del</title>
                      <g id="e26618e8-8cd1-4f9a-8691-3ece40369551" data-name="Слой 2">
                        <g id="07df969b-1707-4ce8-8c09-796a55bc7f26" data-name="Layer 2">
                          <rect x="2.5" y="3.5" width="16" height="20" style="fill:none;stroke:#67676a;stroke-miterlimit:10"/>
                          <rect x="6.5" y="0.5" width="8" height="3" style="fill:none;stroke:#67676a;stroke-miterlimit:10"/>
                          <line y1="3.5" x2="22" y2="3.5" style="fill:none;stroke:#67676a;stroke-miterlimit:10"/>
                          <line x1="6.5" y1="7" x2="6.5" y2="19" style="fill:none;stroke:#67676a;stroke-miterlimit:10"/>
                          <line x1="10.5" y1="7" x2="10.5" y2="19" style="fill:none;stroke:#67676a;stroke-miterlimit:10"/>
                          <line x1="14.5" y1="7" x2="14.5" y2="19" style="fill:none;stroke:#67676a;stroke-miterlimit:10"/>
                        </g>
                      </g>
                    </svg>
                  </span>
                  </a>
                </div>
              </div>
              <div class="mini-bask-one-info-center">
                <quantity-block :item="item" :messages="basket.messages" />
              </div>
              <div class="mini-bask-one-info-right">
                <div class="mini-bask-one-price">
                  {{item.priceFormatted}}
                </div>
                <div class="mini-bask-one-price old-price" v-if="item.basePrice > item.price">
                  {{item.basePriceFormatted}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mini-bask-total">
        <div class="total-line" v-if="basket.discount > 0">
          <div class="mini-bask-total-name">
            {{basket.messages.discountTitle}}:
          </div>
          <div class="mini-bask-total-sum">
            {{basket.discountFormatted}}
          </div>
        </div>
        <div class="total-line">
          <div class="mini-bask-total-name">
            {{basket.messages.summTitle}}:
          </div>
          <div class="mini-bask-total-sum">
            {{basket.summFormatted}}
          </div>
        </div>
        <div class="enter-promo-result" style="display:none;color: #FF0000"></div>
<!--        <div class="enter-promo" v-for="coupon in basket.coupons">-->
<!--          <div class="promo-inp">-->
<!--            <input type="text" :value="coupon" disabled>-->
<!--          </div>-->
<!--          <div class="promo-bt">-->
<!--            <button class="def-bt done" :data-coupon="coupon">-->
<!--              {{basket.messages.applyCupponBtnTitle}}-->
<!--            </button>-->
<!--          </div>-->
<!--        </div>-->
      </div>
      <form  autocomplete="off" method="post" action="" ref="form">
        <div class="accordion-item">
        <div class="one-card-check-other-tit collapsed"
             data-toggle="collapse"
             data-target="#coupon-box"
             aria-expanded="true"
             aria-controls="coupon-box">
                        <span>
                            {{ basket.messages.couponBlockTitle }}
                        </span>
          <i></i>
        </div>
        <div class="one-card-check-other-descr collapse" id="coupon-box">
          <div class="promo-check-form">
            <div class="promo-check-inp">
              <input type="text" name="coupon" :placeholder="basket.messages.couponPlaceholder" value="">
            </div>
            <div class="promo-check-bt">
              <button class="def-bt light" @click.prevent="update('addCoupon')">{{ basket.messages.applyCupponBtnTitle }}</button>
              <br>
            </div>
          </div>
          <div class="enter-promo-result" style="color: #FF0000" v-if="couponError">{{couponError}}</div>
          <div v-if="basket.coupons && basket.coupons.length > 0">
            <div   class="promo-check-form" v-for="(coupon, index) in basket.coupons">
              <div class="promo-check-inp">
                <input type="text" :value="coupon" disabled>
              </div>
              <div class="promo-check-bt">
                <button class="def-bt done" @click.prevent="delCoupon(coupon)"></button>
              </div>
            </div>
          </div>
        </div>
      </div>
      </form>

      <div class="mini-bask-order" v-if="basket.items.length > 0">
        <a class="def-bt" :href="basket.messages.checkoutLink">
          {{basket.messages.checkoutBtntitle}}
        </a>
        <buy_one_click :messages="basket.messages.oneClick"/>
        <a class="def-bt white js-hideminBasket" href="javascript:void(0);" @click="togleBasket">
          {{basket.messages.continue}}
        </a>
      </div>

      <div class="accordion-item" v-if="basket.setProducts.length">
        <div class="one-card-check-other-tit"
             data-toggle="collapse"
             data-target="#buy-complect"
             aria-expanded="true"
             aria-controls="coupon-box">
              <span>{{basket.messages.setProductsPlaceholder}}</span>
          <i></i>
        </div>
        <div class="one-card-check-other-descr buy-complect-slider collapse show" id="buy-complect">
          <BuyComplectSlider :result="basket.setProducts" :messages="basket.messages" @addToBasket="addToBasket"/>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import {mapState, mapActions} from 'vuex';
import BuyComplectSlider from "../sliders/BuyComplectSlider.vue";
import QuantityBlock from "../SmallBasket/quantityBlock.vue";
export default {
  name: "smollBasket",
  components: {QuantityBlock, BuyComplectSlider},
  selector: '.smollBasket',
    data() {
      return {
        loading:false,
        loadingID:false,
        loadingData:false,
        couponError:''
      };
    },
  watch: {
    basket() {
      $(this.$refs.mini_bask_list).mCustomScrollbar("destroy");
      setTimeout(() => {
        $(this.$refs.mini_bask_list).mCustomScrollbar({theme:"my-theme", axis: 'y',});
        addFix2Basket();
      }, 4);
    }
  },
  computed: {
    ...mapState({
      basket: ({basket}) => basket?.data,
    }),
    getBasketCount() {
      let count = 0;
      for(let b in this.basket.items) {
        count+=this.basket.items[b].quantity;
      }
      return count;
    }

  },
  methods: {
    addToBasket(productId) {
      let data = new FormData();

      data.append("func", 'add');
      data.append("handler",'basket');
      data.append("offer",productId);
      data.append("quantity", 1);

      this.axiosWrap(data);
    },
    update(type) {
      this.sendData(type);
    },
    sendData(type, collback,dopParams) {
      if(type===undefined) {
        type = "update";
      }
      console.log(this.$refs.form)
      let data = new FormData(this.$refs.form);
      data.append("func",type);
      data.append("handler",'basket');
      if(dopParams!==undefined) {
        for(let key in dopParams) {
          data.append(key,dopParams[key]);
        }
      }

      this.axiosWrap(data,collback);
    },
    axiosWrap(data,collback) {
      this.loading = true;
      axios.post(this.basket.actionPath, data).then((response)=>{
        if(collback!==undefined) {
          collback(response);
        }

        if (response.data.data.error){
          this.couponError = response.data.data.error ? response.data.data.error : '';
        }
        this.setBasket(response.data.data.basket);
      });
    },
      delCoupon(id) {
        this.sendData("deleteCoupon", undefined,{coupon:id});
      },
      togleBasket() {
      this.$store.commit('basket/changeOpenSmallBasket',!this.basket.isOpenSmallBasket);

      if(this.basket.isOpenSmallBasket) {
        $('#overlay').modal('show');
        setTimeout(() => {
          $(this.$refs.mini_bask_list).mCustomScrollbar({theme:"my-theme", axis: 'y',});
        }, 4);
      } else {
        $('#overlay').modal('hide');
        if (document.querySelector('.has-fancy-row .header-main')) {
          document.querySelector('.has-fancy-row .header-main').style.display = 'none';
        }
        setTimeout(() => {
          $(this.$refs.mini_bask_list).mCustomScrollbar("destroy");
        }, 4);
      }
    },
    setBasket(response){
      this.$store.commit('basket/setState', response);
    },
    del(id) {
      this.$store.dispatch('basket/remove', id);
    },
  },
  mounted() {
    $('#overlay').on('hidden.bs.modal', () => {
      this.$store.commit('basket/changeOpenSmallBasket',false);
    });
  },
  beforeUnmount() {
    $('#overlay').off('hidden.bs.modal');
  }
}
</script>

<style scoped>
.mini-bask-one-info-left {
  display: flex;
  flex-direction: column;
  width: 30%;
}
.mini-bask-one-info-center {
  width: 40%;
}
.mini-bask-one-info-right {
  width: 30%;
}
  .mini-bask-mob {
    padding-top: 1px;
    font-size: 10px;
    cursor: pointer;
    font-weight: bold;
    color: #3c3d41;
    float: left;
    display: -webkit-flex;
    display: -moz-flex;
    display: -ms-flex;
    display: -o-flex;
    display: flex;
    height: 26px;
    align-content: center;
    -ms-align-items: center;
    align-items: center;
    position: relative;
  }
  .mini-bask-mob>span i {
      font-style: normal;
      position: absolute;
      font-size: 9px;
      font-weight: bold;
      right: -10px;
      top: 50%;
      width: 18px;
      height: 18px;
      background-color: #f2c7c1;
      text-align: center;
      border-radius: 50%;
      line-height: 18px;
      margin-top: -14px;
  }
  .mini-bask-mob span {
    display: inline-block;
    background: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEwIDEyLjVIMzBDMzIuNSAxMi41IDM0LjU4MzQgMTUgMzUgMTcuNUwzNy41IDMyLjVDMzcuOTE2OSAzNS4wMDEzIDM1IDM3LjUgMzIuNSAzNy41SDcuNTAwMDNDNS4wMDAwMyAzNy41IDIuMDgzMTQgMzUuMDAxMyAyLjUwMDAzIDMyLjVMNS4wMDAwMyAxNy41QzUuNDE2NyAxNSA3LjUwMDAzIDEyLjUgMTAgMTIuNVoiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iMi41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTEyLjUgMTcuNVY5Ljk3MDk1IiBzdHJva2U9ImJsYWNrIiBzdHJva2Utd2lkdGg9IjIuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0yNy41IDEwVjE3LjUiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iMi41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTIuOTgyOTEgMjkuODkzNUgzNy4wMTcyIiBzdHJva2U9ImJsYWNrIiBzdHJva2Utd2lkdGg9IjIuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0yNy41IDEwQzI3LjUgNy41IDI2LjA0NyA0LjgzNTQ3IDIzLjczNTUgMy41MDA5MkMyMS40MjQgMi4xNjYzNiAxOC41NzYgMi4xNjYzNiAxNi4yNjQ1IDMuNTAwOTJDMTMuOTUzIDQuODM1NDcgMTIuNSA3LjUgMTIuNSAxMCIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIyLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K") 0 0 no-repeat;
    width: 20px;
    height: 20px;
    position: relative;
  }
  .mini-hide-bask {
    display: block;
    position: fixed !important;
    z-index: 2100;
    min-width: 450px;
    max-height: calc(100vh - 100px);
    background-color: #fff;
    top: 68px;
    border: 1px solid black;
    border-radius: 15px;
    right: calc(50% - 225px);
    -webkit-transition: all 0.3s;
    -o-transition: all 0.3s;
    transition: all 0.3s;
    max-width: 100%;
    overflow-x: auto;
  }
  .one-card-check-discount-price {
    padding: 3px 3px;
    font-size: 11px;
    right: -5px;
    left: inherit;
  }
  @media (max-width: 992px) {
    .mini-hide-bask {
      right: 0;
    }
  }
  @media (max-width: 920px) {
    .mini-bask-mob span {
        background: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjMiIGhlaWdodD0iMjciIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEwIDEyLjVIMzBDMzIuNSAxMi41IDM0LjU4MzQgMTUgMzUgMTcuNUwzNy41IDMyLjVDMzcuOTE2OSAzNS4wMDEzIDM1IDM3LjUgMzIuNSAzNy41SDcuNTAwMDNDNS4wMDAwMyAzNy41IDIuMDgzMTQgMzUuMDAxMyAyLjUwMDAzIDMyLjVMNS4wMDAwMyAxNy41QzUuNDE2NyAxNSA3LjUwMDAzIDEyLjUgMTAgMTIuNVoiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iMi41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTEyLjUgMTcuNVY5Ljk3MDk1IiBzdHJva2U9ImJsYWNrIiBzdHJva2Utd2lkdGg9IjIuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0yNy41IDEwVjE3LjUiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iMi41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTIuOTgyOTEgMjkuODkzNUgzNy4wMTcyIiBzdHJva2U9ImJsYWNrIiBzdHJva2Utd2lkdGg9IjIuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0yNy41IDEwQzI3LjUgNy41IDI2LjA0NyA0LjgzNTQ3IDIzLjczNTUgMy41MDA5MkMyMS40MjQgMi4xNjYzNiAxOC41NzYgMi4xNjYzNiAxNi4yNjQ1IDMuNTAwOTJDMTMuOTUzIDQuODM1NDcgMTIuNSA3LjUgMTIuNSAxMCIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIyLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K") 0 0 no-repeat;
          width: 23px;
          height: 27px;
      }
  }
  @media (max-width: 450px) {
    .mini-hide-bask {
      min-width: 100%;
    }
  }

  .mini-bask-tit .close_basket {
      background: url('data:image/png;base64,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');
      display: inline-block;
      width: 18px;
      height: 18px;
      background-size: contain;
      position: absolute;
      right: 15px;
      cursor: pointer;
  }

  .mini-hide-bask .accordion-item {
    padding: 10px;
    float: left;
    width: 100%;
  }
  .mini-bask-order {
     /*margin-top: 40px;*/
  }
  .one-card-check-other-tit {
    font-weight:normal;
  }
  .old-price {
    color: #c5c4be;
  }
</style>